import { useContext } from 'react'
import { StepContext } from 'egi/app/PartnersLine/components/PartnerStep/PartnerStep'

const usePartnerStep = () => useContext(StepContext)

export default usePartnerStep
